import React from "react";
import { Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import { CartProvider } from "./context/CartContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import ThankYou from "./pages/ThankYou";
import TrackOrder from "./pages/TrackOrder";
import About from "./pages/About";
import Privacy from "./pages/Privacy";
import Terms from "./pages/terms";
import FAQ from "./pages/FAQ";

import AnalyticsTracker from "./components/AnalyticsTracker";

function App() {
  return (
    <HelmetProvider>
      <CartProvider>
        {/* Tracks route changes (SPA page views) */}
        <AnalyticsTracker />

        <div className="min-h-screen bg-gray-50 flex flex-col">
          <Navbar />

          <main className="flex-grow">
            <Routes>
              {/* Main Pages */}
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/product/:id" element={<ProductDetail />} />

              {/* Cart & Checkout */}
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/thank-you" element={<ThankYou />} />
              <Route path="/track-order" element={<TrackOrder />} />

              {/* Info Pages */}
              <Route path="/about" element={<About />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/faq" element={<FAQ />} />

              {/* 404 */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>

          <Footer />
        </div>
      </CartProvider>
    </HelmetProvider>
  );
}

// 404 Page Component
const NotFound = () => (
  <div className="min-h-screen flex items-center justify-center bg-white">
    <div className="text-center px-4">
      <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
      <p className="text-xl text-gray-600 mb-8">Page non trouvée</p>
      <a
        href="/"
        className="inline-block bg-gray-900 text-white px-8 py-3 rounded-full font-semibold hover:bg-gray-800 transition-all"
      >
        Retour à l'accueil
      </a>
    </div>
  </div>
);

export default App;
